import React, { useState } from "react"
import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Textarea } from "@/components/ui/textarea"

interface NoteEditModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  initialValue?: string
  onSave: (value: string) => void | Promise<void>
}

export function NoteEditModal({
  open,
  onOpenChange,
  title,
  initialValue = "",
  onSave,
}: NoteEditModalProps) {
  const [value, setValue] = useState(initialValue)
  const [isSaving, setIsSaving] = useState(false)

  // モーダルが開かれた時に初期値をセット
  React.useEffect(() => {
    if (open) {
      setValue(initialValue)
    }
  }, [open, initialValue])

  const handleSave = async () => {
    setIsSaving(true)
    try {
      await onSave(value)
      onOpenChange(false)
    } catch {
      // 表示は共通のトーストが担当。入力を残すため閉じない
    } finally {
      setIsSaving(false)
    }
  }

  const handleCancel = () => {
    setValue(initialValue)
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[619px] p-[25px] gap-[20px]">
        <DialogHeader>
          <DialogTitle className="text-[18px] font-semibold text-[#3f4652]">
            {title}を編集
          </DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-[15px]">
          <Textarea
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="min-h-[283px] resize-none border-slate-300 text-[14px] text-[#3f4652]"
            placeholder={`${title}を入力してください`}
          />
        </div>

        <div className="flex justify-end gap-[20px]">
          <Button
            onClick={handleSave}
            loading={isSaving}
            className="bg-[#354267] hover:bg-[#354267]/90 text-white text-[14px] font-bold h-[32px] px-[16px]"
          >
            保存する
          </Button>
          <Button
            onClick={handleCancel}
            variant="outline"
            className="border-[#354267] text-[#354267] text-[14px] font-bold h-[32px] px-[16px]"
          >
            キャンセル
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
